import { configureStore } from '@reduxjs/toolkit'
import {miscSlice} from './slices/miscSlice'
import { interviewCommentsSlice } from './slices/interviewCommentsSlice'
import { candidateManagementSlice } from './slices/candidateManagementSlice'
import { InterviewManagementSlice } from './slices/InterviewManagementSlice'
import { filterSlice } from './slices/filterOptionsSlice'
import { userSlice } from './slices/userSlice'
import viewCreatedJdsReducer from './slices/viewCreatedJdsSlice'
import { findCandidatesSlice } from './slices/findCandidatesSlice'
import { firstRunGuideSlice } from './slices/firstRunGuideSlice'

export const store = configureStore({
  reducer: {
    miscSlice : miscSlice.reducer,
    interviewCommentsSlice:interviewCommentsSlice.reducer,
    candidateManagementSlice:candidateManagementSlice.reducer,
    interviewManagementSlice:InterviewManagementSlice.reducer,
    filterSlice:filterSlice.reducer,
    userSlice:userSlice.reducer,
    viewCreatedJds: viewCreatedJdsReducer,
    findCandidatesSlice: findCandidatesSlice.reducer,
    firstRunGuide: firstRunGuideSlice.reducer
  },
  devTools: process.env.NODE_ENV !== 'production',
})